// extracted by mini-css-extract-plugin
export var navContainer = "layout-module--nav-container--lv6SL";
export var navItem = "layout-module--nav-item--NnDHw";
export var navItemAvatar = "layout-module--nav-item-avatar--fjYPw";
export var navLinkItem = "layout-module--nav-link-item--pfCo2";
export var navLinkActive = "layout-module--nav-link-active--PYKFX";
export var navHeader = "layout-module--nav-header--tBuyP";
export var navFooter = "layout-module--nav-footer--rolpg";